import React, { useEffect, useState } from 'react'
import axios from 'axios'

import Btn from '../ui/Btn'
import './challenges.css'

/*
 * ONE LANGUAGE of one content record.
 *
 * GET  admin/challenges/challengelang/:ChallengeID/:LangUUID
 * POST admin/challenges/challengelang        { ...record, LangID, ChallengID }
 * GET  admin/challenges/challengelangdel/:UUID
 *
 * All three untouched — same URLs, same payload keys (ChallengID included,
 * spelled exactly as the API expects it), same headers.
 *
 * Presentation only: token-styled fields with their labels above them, the
 * server's message shown inline instead of through alert(), and deleting a
 * translation asks for confirmation in the page rather than in a browser box.
 */

export default function ChallengeLangForm(props) {
    const [record,setRecord]=useState({id:0,Title:'',Descr:''})
    const [isLoading,setIsLoading]=useState(false)
    const [saving,setSaving]=useState(false)
    const [note,setNote]=useState(null)
    const [confirming,setConfirming]=useState(false)

    /* The endpoint answers with nothing at all for a language that was never
       written, so every read goes through a guard instead of through the raw
       state — the old form crashed on exactly that. */
    const rec=record || {}
    const val=(v)=>(v===undefined || v===null ? '' : v)

    useEffect(()=>{
        loadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const save=(e)=>{
        e.preventDefault()
        setNote(null)
        setSaving(true)
        const obj={...record,LangID:props.LangID,ChallengID:props.id}
        axios.post(process.env.REACT_APP_API_SERVER+'admin/challenges/challengelang',obj,{
            headers: {
                'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
                }
            })
          .then(res=>{
            //console.log(res.data)
            setSaving(false)
            setNote({tone:'good',text:res.data.msg})
            loadData()
          }).catch(err=>{
            setSaving(false)
            setNote({tone:'crit',text:'Υπήρξε ένα πρόβλημα, παρακαλώ προσπαθήστε ξανά'})
          })
    }

    const loadData=()=>{
        setIsLoading(true)
        axios.get(process.env.REACT_APP_API_SERVER+'admin/challenges/challengelang/'+props.id+'/'+props.LangID,{
            headers: {
                'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
                }
            })
          .then(res=>{

            setRecord(res.data.results)

            //console.log(res.data.results)
            setIsLoading(false)

          }).catch(err=>{
              setIsLoading(false)

          })
    }

    const del=()=>{
            setConfirming(false)
            setNote(null)
            axios.get(process.env.REACT_APP_API_SERVER+'admin/challenges/challengelangdel/'+rec.UUID,{
                headers: {
                    'Authorization': 'Bearer '+sessionStorage.getItem("apiToken")
                    }
                })
              .then(res=>{
                loadData()
                setNote({tone:'good',text:res.data.msg})


              }).catch(err=>{
                  setIsLoading(false)
                  setNote({tone:'crit',text:'Υπήρξε ένα πρόβλημα, παρακαλώ προσπαθήστε ξανά'})
              })

    }

  return (
    <form className="chx-form" onSubmit={save}>

        {isLoading && (
          <div className="chx-sk">
            <div className="skeleton chx-sk-line"></div>
          </div>
        )}

        {note && (
          <div className={note.tone==='crit' ? 'chx-note chx-note-crit' : 'chx-note chx-note-good'} role="status">
            <span className="chx-note-text">{note.text}</span>
          </div>
        )}

        <div className="chx-fields">

          <div className="chx-field chx-field-wide">
            <label className="chx-label" htmlFor={'chlang-title-'+props.LangID}>Τίτλος Challenge</label>
            <input
              id={'chlang-title-'+props.LangID}
              className="chx-input"
              type="text"
              required
              value={val(rec.Title)}
              onChange={(e)=>setRecord({...rec,Title:e.target.value})}
            />
          </div>

          <div className="chx-field chx-field-wide">
            <label className="chx-label" htmlFor={'chlang-descr-'+props.LangID}>Περιγραφή</label>
            <textarea
              id={'chlang-descr-'+props.LangID}
              className="chx-textarea"
              rows={4}
              value={val(rec.Descr)}
              onChange={(e)=>setRecord({...rec,Descr:e.target.value})}
            />
          </div>

        </div>

        {confirming && (
          <div className="chx-confirm" role="alertdialog" aria-label="Επιβεβαίωση διαγραφής">
            <span className="chx-confirm-text">ΔΙΑΓΡΑΦΗ, ΣΙΓΟΥΡΑ?</span>
            <span className="chx-confirm-act">
              <Btn onClick={()=>setConfirming(false)}>Άκυρο</Btn>
              <Btn className="chx-btn-crit" onClick={del}>Ναι, διαγραφή</Btn>
            </span>
          </div>
        )}

        <div className="chx-actions chx-actions-spread">
          {rec.UUID
            ? <Btn className="chx-btn-crit" onClick={()=>setConfirming(true)} disabled={confirming}>Διαγραφή</Btn>
            : <span></span>}

          <span className="chx-actions-right">
            <Btn type="submit" variant="accent" disabled={saving}>
              {saving ? 'Αποθήκευση…' : 'Αποθήκευση'}
            </Btn>
          </span>
        </div>

    </form>
  )
}
